import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllInterviews } from "../../../redux/actions";
import InterviewCard from "../../PostAJob/EmployerProfile/components/interviewCard/InterviewCard";
import Loader from "../../../components/Loading/Loader";
import EmptyInterviews from "../../../assets/img/EmptyInterviews1.png";
import "./InterviewListing.css";
import moment from "moment";
import { Row, Col } from "antd";
import FeatureGate from "../../FeatureGate/FeatureGate";
import { canUseSubscriptionFeatures } from "../../../shared/billing";

const InterviewListing = () => {
  const subscriptionFeaturesEnabled = canUseSubscriptionFeatures();
  const interviews = useSelector(
    (state) => state.getAllInterviewsReducer.interviews
  );
  const loading = useSelector((state) => state.getAllInterviewsReducer.loading);
  const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
  const creditsBalanceLoaded = useSelector((state) => state.plansReducer?.creditsBalanceLoaded);

  const dispatch = useDispatch();
  const date = moment().format("dddd, MMMM DD, YYYY");

  useEffect(() => {
    dispatch(getAllInterviews());
  }, []);

  if (subscriptionFeaturesEnabled && !creditsBalanceLoaded) return <Loader />;
  if (subscriptionFeaturesEnabled && creditsBalance?.data?.status === 'expired') return (
    <FeatureGate
      featureName="Interviews"
      iconType="candidate"
      description="Your plan has expired. You cannot view or manage your scheduled interviews. Choose a plan to continue."
      bottomText="Interviews is a paid feature and was given to you for free during your trial period."
    />
  );

  return loading ? (
    <Loader />
  ) : interviews.length === 0 ? (
    // <Loader />
    <div className="interviews-page-main-div">
      <div>
        <div className="int-list-mainhead"> Interviews</div>
        <div className="int-list-date">{date}</div>
      </div>
      <div className="int-list-center">
        <img
          src={EmptyInterviews}
          alt="EmptyInterviewpic"
          className="nointerviewdataimage"
        ></img>
        <div className="nointerviewdatatext">No interviews for today</div>
      </div>
      <div className="int-list-divider"></div>
    </div>
  ) : (
    <div style={{'background-color' : '#fff'}} >
      <div>
        <div className="int-list-mainhead"> Interviews</div>
        <div className="int-list-date">{date}</div>
      </div>

      <div className="int-list-divider"></div>
      <div className="all-interviews-containerbox-parent">
      <Row className="all-interviews-containerbox" >
        {interviews.map((item, index) => {
          return (
            <Col
              className={"interview-cards-container"} key={index}
>
              <InterviewCard
                {...item}
              
              />
            </Col>
          );
        })}
          </Row>
          </div>
         </div> 
   
  );
};

export default InterviewListing;
